const permissions = {
    methods: {
        getUserPagePermission( page )
        {
            const permissions = JSON.parse(this.$cookies.get('permission'));

            if( page == '' ) return { read: true, write: true };

            return permissions.find( el => el.type == page );
        }
    }
}

export default permissions;